import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/case-of-the-month.svg")